import React, { useState } from 'react';
import '../Home/Home.css';

const TechServiceCard = ({ service, index }) => {
    const [isHovered, setIsHovered] = useState(false);

    const techIcons = ['⚛️', '🚀', '🔒', '☁️', '🤖', '💻'];
    const techColors = ['#ff7e5f', '#61DAFB', '#4CAF50', '#FF9800', '#9C27B0', '#2196F3'];
    const techGradients = [
        'linear-gradient(135deg, #ff7e5f, #ff512f)',
        'linear-gradient(135deg, #61DAFB, #21a1f1)',
        'linear-gradient(135deg, #4CAF50, #2E7D32)',
        'linear-gradient(135deg, #FF9800, #F57C00)',
        'linear-gradient(135deg, #9C27B0, #6A1B9A)',
        'linear-gradient(135deg, #2196F3, #0D47A1)'
    ];

    return (
        <div
            className={`tech-service-card ${isHovered ? 'hovered' : ''}`}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
                '--tech-color': techColors[index % techColors.length],
                '--tech-gradient': techGradients[index % techGradients.length]
            }}
        >
            {/* Effet holographique */}
            <div className="hologram-effect"></div>

            {/* Carte principale */}
            <div className="tech-card-inner">
                {/* Header avec effets tech */}
                <div className="tech-card-header">
                    <div className="tech-icon-container">
                        <div className="tech-icon-bg">
                            <span className="tech-icon">{techIcons[index % techIcons.length]}</span>
                        </div>
                        <div className="tech-icon-glow"></div>
                        <div className="tech-icon-pulse"></div>
                    </div>

                    <div className="tech-card-title-wrapper">
                        <h3 className="tech-card-title">{service.title}</h3>
                        <div className="tech-title-underline"></div>
                    </div>

                    <div className="tech-badge">TECH+</div>
                </div>

                {/* Contenu */}
                <div className="tech-card-content">
                    <p className="tech-card-description">{service.description}</p>

                    {/* Stack technologique */}
                    <div className="tech-stack">
                        <span className="tech-stack-item">React</span>
                        <span className="tech-stack-item">Node.js</span>
                        <span className="tech-stack-item">AWS</span>
                        <span className="tech-stack-item">AI</span>
                    </div>

                    {/* Stats */}
                    <div className="tech-card-stats">
                        <div className="tech-stat">
                            <div className="tech-stat-value">99.9%</div>
                            <div className="tech-stat-label">Perf</div>
                        </div>
                        <div className="tech-stat">
                            <div className="tech-stat-value">24/7</div>
                            <div className="tech-stat-label">Support</div>
                        </div>
                        <div className="tech-stat">
                            <div className="tech-stat-value">∞</div>
                            <div className="tech-stat-label">Scale</div>
                        </div>
                    </div>
                </div>

                {/* Footer avec CTA */}
                <div className="tech-card-footer">
                    <div className="tech-cta-container">
                        <button className="tech-cta-button">
                            <span className="cta-text">EXPLORER</span>
                            <span className="cta-icon">→</span>
                            <div className="cta-glow"></div>
                        </button>
                        <div className="tech-tags">
                            <span className="tech-tag">HIGH-TECH</span>
                            <span className="tech-tag">INNOVATION</span>
                        </div>
                    </div>
                </div>

                {/* Effets de bordure */}
                <div className="border-effect top-border"></div>
                <div className="border-effect right-border"></div>
                <div className="border-effect bottom-border"></div>
                <div className="border-effect left-border"></div>

                {/* Points de connexion */}
                <div className="connection-points">
                    <div className="connection-point"></div>
                    <div className="connection-point"></div>
                    <div className="connection-point"></div>
                    <div className="connection-point"></div>
                </div>
            </div>

            {/* Effets de particules au survol */}
            {isHovered && (
                <>
                    <div className="hover-particle particle-1"></div>
                    <div className="hover-particle particle-2"></div>
                    <div className="hover-particle particle-3"></div>
                </>
            )}
        </div>
    );
};

export default TechServiceCard;